import Icon from "../Icon/Icon";

export interface CounterProps {
  value?: number;
  onDecreaseClick?: () => void;
  onIncreaseClick?: () => void;
  step?: string;
  onChange?: any;
  variant?: "medium" | "large";
  label?: string;
}

const Counter = ({
  value = 1.5,
  step = "0.50",
  onDecreaseClick,
  onChange,
  onIncreaseClick,
  variant = "medium",
  label,
}: CounterProps) => {
  return (
    <div>
      {label && (
        <div className="font-semibold mb-[1rem]">
          {label}
        </div>
      )}
      <div className="flex h-11">
        <div
          className={`flex items-center bg-grey ${variant === "large" ? "px-[2rem] py-[1.75rem]" : "px-[0.75rem] py-0"} mr-[0.15rem] rounded-l-[0.5rem]`}
          style={{ cursor: onDecreaseClick !== undefined ? "pointer" : "default" }}
          onClick={onDecreaseClick}
        >
          <Icon
            className={
              variant === "large"
                ? "h-6 w-6 fill-dark"
                : "h-[1.2rem] w-[1.2rem] fill-dark"
            }
            variants="minus"
          />
        </div>
        <input
          className={`appearance-none border-none bg-grey text-center font-bold text-dark outline-none [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none ${variant === "large" ? "w-[8rem] px-[0.75rem] py-[1.75rem] text-[1.8rem]" : "w-[4rem] px-[0.75rem] py-0 text-[1.6rem]"}`}
          step={step}
          value={value}
          onChange={(e) => onChange && onChange(e.target.value)}
          type="number"
          disabled={!onChange}
        />
        <div
          className={`flex items-center bg-grey ${variant === "large" ? "px-[2rem] py-[1.75rem]" : "px-[0.75rem] py-0"} ml-[0.1rem] rounded-r-[0.5rem]`}
          style={{ cursor: onIncreaseClick !== undefined ? "pointer" : "default" }}
          onClick={onIncreaseClick}
        >
          <Icon
            className={
              variant === "large"
                ? "h-6 w-6 fill-dark"
                : "h-[1.2rem] w-[1.2rem] fill-dark"
            }
            variants="plus"
          />
        </div>
      </div>
    </div>
  );
};

export default Counter;
